module.exports = __webpack_public_path__ + "img/accounts.8654b8f0.svg";